import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    width: 200,
    display: "flex",
    alignItems: "right",
  },
  ratingLabel: {
    fontSize: "12px",
    marginLeft: "5px",
    marginTop: "-5px",
    marginBottom:"10px"
    // marginLeft: "7px",
  },
});

export default function AdyaTimeStamp(props) {
  const classes = useStyles();

  let date = new Date();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let AmPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  let timeStamp = hours + ":" + minutes + " " + AmPm;
  // console.log("timeStamp: ", timeStamp);

  return (
    <div className={classes.root}>
      <span className={classes.ratingLabel}>{timeStamp}</span>
    </div>
  );
}
